import Button from 'components/actions/Button';

interface TableErrorProps {
    id?: string;
    header: string;
    message?: string;
    onClick?(): void;
}

const TableError = ({ id, header, message, onClick }: TableErrorProps) => {
    const refreshPage = () => location.reload();
    return (
        <div className='TableError' data-testid={`system-admin-table-error-${id}`}>
            <div>
                <span className='rioglyph rioglyph-error-sign TableError__icon' />
            </div>
            <div>
                <p className='TableError__header' data-testid={`system-admin-table-error-${id}-header`}>
                    {header}
                </p>
                <p className='TableError__message'>
                    {message ?? 'If this issue persists, please contact the Control Center support team.'}
                </p>
                <Button
                    onClick={onClick ?? refreshPage}
                    style='danger'
                    data-testid={`system-admin-table-error-${id}-button`}
                >
                    <span className='rioglyph rioglyph-repeat' aria-hidden='true' />
                    Refresh table
                </Button>
            </div>
        </div>
    );
};

export default TableError;
